import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, Modal, Container, Row, Col } from "react-bootstrap";

import "./VariationsModal.scss";

import messages from "../../assets/i18n";
import ButtonStandard from "../ButtonStandard/ButtonStandard";
import VariationsHoursModal from "../VariationsHoursModal/VariationsHoursModal";
import { ToastMessage } from "../../components";

function VariationsModal(props) {

    const dispatch = useDispatch();

    const gateSelect = useSelector(state => state.gateVariations.gateSelect)
    const idGate = useSelector(state => state.gateVariations.idGate)
    const listVariations = useSelector(state => state.gateVariations.gateVariation)
    const error = useSelector(state => state.gateVariations.gateVariationError)
    const lang = useSelector(state => state.language.name);
    const [modalVariationHours, setModalVariationHours] = useState(false);
    const [action, setAction] = useState();
    const [dynamicCapacityEnable, setDynamicCapacityEnable] = useState(false);
    const gateVariationError = useSelector(state => state.gateVariations.gateVariationError);
    const gateVariationSuccess = useSelector(state => state.gateVariations.gateVariationSuccess);
    const [toastMessage, setToastMessage] = useState('');
    const [toastClass, setToastClass] = useState('toast-error');
    const [show, setShow] = useState(false);

    const deleteVariation = (id) => {
        dispatch({
            type: "DELETE_GATE_VARIATION",
            payload: {
                id: id,
                idGate: idGate
            }
        });
    }

    const createVariation = () => {
        dispatch({
            type: "SET_VARIATION_HOURS_MODAL_CLEAN"
        });
        setAction('create')
        setModalVariationHours(true)
    }

    const editVariation = (gateVariation) => {
        setDynamicCapacityEnable(false)

        const horarios = gateVariation.novosHorarios.sort((prev, next) => {
            return prev.idDiaSemana < next.idDiaSemana ? -1 : prev.idDiaSemana > next.idDiaSemana ? 1 : 0;
        });

        horarios.forEach(hour => {
            if (hour.carga !== 1) {
                setDynamicCapacityEnable(true)
            }
        })

        const initialDate = convertDate(gateVariation.dataInicial)
        const finalDate = convertDate(gateVariation.dataFinal)

        dispatch({
            type: "SET_HOURS",
            payload: {
                id: gateVariation.id,
                motivo: gateVariation.motivo,
                initialDate: initialDate,
                finalDate: finalDate,
                horarios: horarios
            }
        });
        setAction('edit')
        setModalVariationHours(true)
    }

    const convertDate = (date) => {
        const [day, month, year] = date.split('/');

        const result = [year, month, day].join('-');

        return result;
    }

    useEffect(() => {
        if (gateVariationError.error === true) {
            let messageCode = gateVariationError.data.messageCode;
            if (messageCode !== 'variation010') {
                setShow(true);
                setToastMessage(messages[lang].messagesCode[messageCode]);
                setToastClass('toast-error');
            } else {
                alert(messages[lang].messagesCode[messageCode])
            }
            dispatch({ type: "SET_GATE_VARIATION_ERROR", payload: { error: false } });
        }

        if (gateVariationSuccess.success === true) {
            let messageCode;
            if (gateVariationSuccess.type === 'save') {
                messageCode = 'variation002';
            } else if (gateVariationSuccess.type === 'delete') {
                messageCode = 'variation003';
            } else {
                messageCode = 'variation001';
            }
            setShow(true);
            setToastMessage(messages[lang].messagesCode[messageCode]);
            setToastClass('toast-success');
            dispatch({ type: "SET_GATE_VARIATION_SUCCESS", payload: { success: false } });
        }

        // eslint-disable-next-line
    }, [gateVariationError, gateVariationSuccess]);

    const closeVariationsHoursModal = () => {
        dispatch({
            type: "SET_VARIATION_HOURS_MODAL_CLEAN"
        });
        setModalVariationHours(false)
    }

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            className="gate-variation-modal"
            centered
        >
            <ToastMessage show={show} setShow={setShow} message={toastMessage} toastClass={toastClass} ></ToastMessage>
            <Modal.Body>
                <Container className="px-0">
                    <Row>
                        <Col xs={10}>
                            <Form.Group bsPrefix={"form-group-custom"} >
                                <Form.Label>{messages[lang].gate}:</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={gateSelect}
                                    maxLength={50}
                                    disabled />
                            </Form.Group>
                        </Col>
                        <Col xs={2}>
                            <ButtonStandard
                                text={messages[lang].newVariation}
                                textClass="text-1"
                                className="btn-primary btn-sm btn-standard btn-exception"
                                action="create"
                                onClick={() => createVariation()} />
                        </Col>

                    </Row>
                    {error !== true ?
                        <Container className="scroll">
                            <Row className="text-center">
                                <Col xs={7} className="bg-color-tertiary border-left-right-bottom py-2 extra-rounded-top-left text-left">
                                    <span className="text-2 text-color-tertiary">
                                        {messages[lang].reason}
                                    </span>
                                </Col>
                                <Col xs={2} className="bg-color-tertiary border-left-right-bottom py-2 ">
                                    <span className="text-2 text-color-tertiary">
                                        {messages[lang].initialDate}
                                    </span>
                                </Col>
                                <Col xs={2} className="bg-color-tertiary border-left-right-bottom py-2 ">
                                    <span className="text-2 text-color-tertiary">
                                        {messages[lang].finalDate}
                                    </span>
                                </Col>
                                <Col xs={1} className="bg-color-tertiary border-left-right-bottom py-2 extra-rounded-top-right">
                                    <span className="text-2 text-color-tertiary">
                                        {messages[lang].edit}
                                    </span>
                                </Col>
                            </Row>

                            <div className="gate-variation-modal">
                                {listVariations.map((gateVariation, i) => {
                                    return (
                                        <Row className="text-center" key={i}>
                                            <Col xs={7} className="bg-color-secondary border-left-right-bottom py-2 text-left">
                                                <span className="text-2 text-color-tertiary">
                                                    {gateVariation.motivo}
                                                </span>
                                            </Col>
                                            <Col xs={2} className="bg-color-secondary border-left-right-bottom border-right py-2 ">
                                                <span className="justify-content-center text-2 text-color-tertiary">
                                                    {gateVariation.dataInicial}
                                                </span>
                                            </Col>
                                            <Col xs={2} className="bg-color-secondary border-left-right-bottom border-right py-2 ">
                                                <span className="text-2 text-color-tertiary">
                                                    {gateVariation.dataFinal}
                                                </span>
                                            </Col>
                                            <Col xs={1} className="bg-color-secondary border-bottom">
                                                <Row>
                                                    <button className="btn-pen"
                                                        onClick={() => editVariation(gateVariation)}>
                                                        <i className="icon-pen" />
                                                    </button>
                                                    <button className="btn-remove"
                                                        onClick={() => deleteVariation(gateVariation.id)}>
                                                        <i className="icon-remove" />
                                                    </button>
                                                </Row>
                                            </Col>
                                        </Row>
                                    )
                                })}

                            </div>
                        </Container>
                        :
                        <Container>
                            <h1>{messages[lang].NotFoundVariations}</h1>
                        </Container>
                    } {
                        (modalVariationHours) ?
                            <VariationsHoursModal
                                show={modalVariationHours}
                                onHide={() => { closeVariationsHoursModal() }}
                                value={dynamicCapacityEnable}
                                action={action}
                            />
                            :
                            <></>
                    }
                </Container>

            </Modal.Body>
            <Modal.Footer>
                <ButtonStandard
                    id="load_modal_add_order_button"
                    text={messages[lang].closer}
                    textClass="text-3"
                    onClick={() => props.onHide(false)}
                    className="btn btn-primary btn-standard px-4 py-1"
                />
            </Modal.Footer>
        </Modal>
    )
}

export default VariationsModal;